import { DettaglioEsito } from '../../../models/dettaglio-esito';

export class DettaglioEsitoAdapter {

    static cloneMerito(meritoEsito: DettaglioEsito): DettaglioEsito {
      let meritoClone: DettaglioEsito = new DettaglioEsito();
      if (meritoEsito.id) {
        meritoClone.id = meritoEsito.id;
      }
      meritoClone.tipoDettaglio = meritoEsito.tipoDettaglio ? JSON.parse(JSON.stringify(meritoEsito.tipoDettaglio)) : null;
      meritoClone.classificazione = meritoEsito.classificazione ? JSON.parse(JSON.stringify(meritoEsito.classificazione)) : null;
      meritoClone.controparte = meritoEsito.controparte ? JSON.parse(JSON.stringify(meritoEsito.controparte)) : null;
      return meritoClone;
    }
}
